/*@ngInject*/
const SectionTemplateRepository = function (baseRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.getSectionTemplatesByName = function (nameSearchString, requestParams) {
        const url = '/rest/SectionTemplate',
            config = {
                params: {
                    nameSearchString: nameSearchString,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.saveSectionTemplate = function (sectionTemplate) {
        let url = '/rest/SectionTemplate';
        const body = sectionTemplate,
            config = {
                params: {}
            };

        if (sectionTemplate.id) {
            url = '/rest/SectionTemplate/' + sectionTemplate.id;
        }
        return this.post(url, body, config);
    };

    this.reloadSectionTemplateRules = function (validate) {
        const url = '/rest/SectionTemplate/reloadRules',
            config = {
                params: {
                    validate: validate
                }
            };

        return this.post(url, {}, config);
    };

    this.uploadQuoteDocumentTemplateFile = function (sectionTemplate, quoteDocumentTemplateFile) {
        const url = '/sectionTemplateUpload',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params: {
                    sectionTemplateId: sectionTemplate.id,
                    documentTemplateName: sectionTemplate.documentTemplateName,
                    size: quoteDocumentTemplateFile.size
                }
            };

        formData.append('Filedata', quoteDocumentTemplateFile);

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

    this.deleteSectionTemplate = function (sectionTemplateId) {
        let url = `/rest/SectionTemplate/${sectionTemplateId}`;
        return this.delete(url);
    };

    this.markInProduction = function (sectionTemplateId) {
        let url = `/rest/SectionTemplate/${sectionTemplateId}/markInProduction`;
        const config = {
                params: {}
            };

        return this.post(url, null, config);
    }
};

angular.module('ums.configuration')
    .service('sectionTemplateRepository', SectionTemplateRepository);
